import UploadDocument from './UploadDocument';

export default UploadDocument;
